<template>
  <el-container style="height:100%">
    <el-header
      style="height:35px;padding:0px;background-color:aliceblue;border: 0px solid #d1dbe5;border-top-width:1px"
    >
      <el-breadcrumb class="header-bread">
        <el-breadcrumb-item>基本参数</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <el-main style="padding:0px;height:100%">
      <el-collapse
        v-model="activeNames"
        @change="handleChange"
        class="PropertyTitle"
        accordion
      >
        <el-collapse-item title="样式" name="1">
          <style-form
            ref="styleform"
            :formData="formData"
            :ifChange="ifChange"
            @StyleChange="handleProperChange"
          ></style-form>
        </el-collapse-item>
        <el-collapse-item title="文本" name="2">
          <text-form
            ref="textform"
            :formData="formData"
            :ifChange="ifChange"
            @TextChange="handleProperChange"
          ></text-form>
        </el-collapse-item>
        <el-collapse-item title="布局" name="3">
          <arrange-form
            ref="arrangeform"
            :formData="formData"
            :ifChange="ifChange"
            @ArrangeChange="handleProperChange"
          ></arrange-form>
        </el-collapse-item>
      </el-collapse>
    </el-main>
  </el-container>
</template>

<script>
import styleForm from "./style-porperty.vue"; //样式
import textForm from "./text-porperty.vue"; //文本
import arrangeForm from "./arrange-porperty.vue"; //布局

export default {
  components: {
    styleForm,
    textForm,
    arrangeForm
  },
  props: {
    formData: {
      type: Object,
      default() {
        return null;
      }
    },
    porperEvent: Object,
    ifChange: {
      type: Number,
      default: 0
    }
  },
  watch: {
    formData: function(value) {
      // debugger;
      // if (value != null && value != undefined) {
      //   if (
      //     value.target.cellType == "qrCode" ||
      //     value.target.cellType == "barCode" ||
      //     value.target.cellType == "fx" ||
      //     value.target.cellType == "text"
      //   ) {
      //     this.activeNames = ["2"];
      //   } else {
      //     this.activeNames = ["1"];
      //   }
      // } else {
      //   this.activeNames = ["1"];
      // }
    }
  },
  data() {
    return {
      activeNames: ["1", "2", "3", "4"],
      selectCell: ""
    };
  },
  methods: {
    handleChange() {
      this.$refs.textform._setLabelHeight();
      //this._setLabelHeight();
    },
    handleProperChange(data) {
      this.porperEvent.$emit("porpertyChange", data);
    }
  },
  mounted() {
    this.activeNames = ["1"];
  }
};
</script>

<style scoped>
.header-bread {
  margin-top: 8px;
  margin-left: 10px;
  font-size: 20px;
  font-weight: bold !important;
}
.PropertyTitle >>> .el-collapse-item__header {
  font-size: 18px !important;
  font-weight: bold !important;
  padding: 0px 0px 0px 10px;
  background-color: aliceblue;
}
</style>
